// Localização: frontend/src/components/Management/MedicamentoForm.js


import React, { useState } from 'react';
import PrimaryButton from '../Common/PrimaryButton';

const MedicamentoForm = ({ initialData, onSubmit, onClose, isEditing }) => {
    const [formData, setFormData] = useState({
        nome_medicamento: '',
        dose: '',
        unidade_medida: '',
        instrucoes: '',
        ...initialData
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.nome_medicamento || !formData.dose || !formData.unidade_medida) {
            setError('Nome, Dosagem e Unidade de Medida são obrigatórios.');
            return;
        }
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="p-4">
            <h3 className="text-lg font-bold mb-4">{isEditing ? 'Editar Medicamento' : 'Novo Medicamento'}</h3>
            
            {error && <p className="text-red-500 mb-4">{error}</p>}

            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nome</label>
                <input
                    type="text"
                    name="nome_medicamento"
                    value={formData.nome_medicamento}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                    required
                />
            </div>
            <div className="grid grid-cols-3 gap-4 mb-4">
                <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700">Dosagem</label>
                    <input
                        type="text"
                        name="dose"
                        value={formData.dose}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                        required
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Unidade (ex: mg, ml)</label>
                    <input
                        type="text"
                        name="unidade_medida"
                        value={formData.unidade_medida}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                        required
                    />
                </div>
            </div>
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Instruções/Descrição</label>
                <textarea
                    name="instrucoes"
                    value={formData.instrucoes || ''}
                    onChange={handleChange}
                    rows="3"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                />
            </div>
            
            <div className="flex justify-end space-x-2 mt-6">
                <PrimaryButton type="button" onClick={onClose} className="bg-gray-500 hover:bg-gray-700">Cancelar</PrimaryButton>
                <PrimaryButton type="submit">{isEditing ? 'Salvar Alterações' : 'Cadastrar'}</PrimaryButton>
            </div>
        </form>
    );
};

export default MedicamentoForm;